import locale from "localization/en";

export const bankDepositColumns = [
  {
    key: "bankDepositId",
    text: locale.depositID,
    style: {
      width: "120px",
    },
  },
  {
    key: "shiftDate",
    text: locale.shiftDateAndTime,
    style: {
      width: "auto",
      minWidth: "200px",
    },
  },
  {
    key: "depositedAt",
    text: locale.depositDateAndTime,
    style: {
      width: "160px",
    },
  },
  {
    key: "amount",
    text: locale.amountDeposited,
  },
  { key: "type", text: locale.depositType },
  { key: "viewAttachment", text: locale.viewAttachment },
  { key: "actions", text: locale.action },
];
